import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

import Carousel1 from '../../images/carousel.jpg';
import Carousel2 from '../../images/giftcard.jpg';
import Carousel3 from '../../images/footSide.jpg';
import Carousel4 from '../../images/handSide.jpg';
import Carousel5 from '../../images/frontView.jpg';

import './index.scss';

const Banner = () => {
	return (
		<div className='banner-wrapper'>
			<Carousel>
				<Carousel.Item>
					<img className='d-block w-100' src={Carousel1} alt='First slide' />
					<Carousel.Caption>
						<h3>Amy's Nails & Spa</h3>
						<p>The best place to treat your body to a New Experience!</p>
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={Carousel2} alt='Third slide' />

					<Carousel.Caption>

					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={Carousel3} alt='Second slide' />

					<Carousel.Caption>

					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={Carousel4} alt='Second slide' />

					<Carousel.Caption>

					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item>
					<img className='d-block w-100' src={Carousel5} alt='Second slide' />

					<Carousel.Caption>
					
					</Carousel.Caption>
				</Carousel.Item>
			</Carousel>
		</div>
	);
};

export default Banner;
